import { combineReducers } from 'redux';

import config from './config';
import availableLanguages from './available-languages';

export default function createReducer(dynamicReducers = {}) {
  return combineReducers({
    config,
    availableLanguages,
    ...dynamicReducers,
  });
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/store/reducers/index.ts